import ReportOperatorVenditeFilters from "../../components/filters/ReportOpeVenditeFilters";
import Loader from "../../components/main/Loader";
import { AdapterReportFilterOpVendite } from "../../helpers/adapter/filters/AdapterFilterReportOp";
import { saveAs } from 'file-saver';
import { useGetReportOpVenditeMutation } from "../../store/services/ReportService";
import { toast } from "react-toastify";
import { useGetUserRoleQuery } from "../../store/services/LookUpService";

export default function ReportOpVendite() {
    let { data: operatoreData, isLoading: isLoadingOp } = useGetUserRoleQuery({role: 'Operatore' });
    const [getReportOpVendite, requestReport] = useGetReportOpVenditeMutation()

    const handleSetFilter = async (dataFilter: any) => {
        const mapFilter: any = AdapterReportFilterOpVendite(dataFilter);
        let result: any = await getReportOpVendite(mapFilter);

        if ('error' in result) {
            console.log('ERROR DOWNLOAD')
        } else {
            saveAs(result?.data, `VenditeOperatori_${Date.now()}.xlsx`)
            toast.success(`Report scaricato`);
        }
    }

    return(
        <>
            {isLoadingOp || requestReport.isLoading ? <Loader /> : null}
            <ReportOperatorVenditeFilters methodParent={handleSetFilter} operatoreData={operatoreData} />
            {requestReport?.isError 
                ? 
                <div className="mt-8 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
                    <p className="font-bold">Attenzione</p>
                    <p>Nessun risultato presente per i parametri selezionati</p>
                </div>
                : null
            }
        </>
    )
}
